import { render, staticRenderFns } from "./TeacherCardNameLabel.vue?vue&type=template&id=6a808185&scoped=true&"
import script from "./TeacherCardNameLabel.vue?vue&type=script&lang=js&"
export * from "./TeacherCardNameLabel.vue?vue&type=script&lang=js&"
import style0 from "./TeacherCardNameLabel.vue?vue&type=style&index=0&id=6a808185&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a808185",
  null
  
)

export default component.exports